import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useModifyGuestBookingSubmit } from './hooks/useModifyGuestBookingSubmit';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { ErrorBar } from '../../../../shared/components';
import { DialogHeader, DialogMain } from '../../../../shared/components/dialog';
import { setHash } from '../../../../shared/router/hash/hashHistory';
import { IBooking } from '../../../domain/booking/models/IBooking';
import { getBookingDetailsHash } from '../details';
import { GuestBookingForm } from './GuestBookingForm';

export const ModifyGuestBookingDialog = observer(() => {
	const { t } = useTranslation();
	const [error, setError] = useState<Error | undefined>(undefined);

	const handleSuccess = (booking: IBooking) => {
		const bookingDetailsHash = getBookingDetailsHash(booking.reference);

		setHash(bookingDetailsHash);
	};

	const { onSubmit } = useModifyGuestBookingSubmit({
		onSuccess: handleSuccess,
		onError: setError,
	});

	return (
		<>
			<DialogHeader title={t('parking_modify_guest_booking_dialog_header')} />
			<DialogMain>
				<p>{t('parking_modify_guest_booking_dialog_body')}</p>
				<GuestBookingForm
					onSubmit={onSubmit}
					submitButtonText={t(
						'parking_modify_guest_booking_dialog_submit_button',
					)}
				/>
			</DialogMain>
			{error && (
				<ErrorBar>{t('parking_retrieve_booking_generic_error')}</ErrorBar>
			)}
		</>
	);
});
